import React from 'react';
import { SvgIcon } from '@mui/material';

function SearchIcon({ ...props }) {
  return (
    <SvgIcon {...props} viewBox="0 0 88 108">
      <path
        d="M86.7002 100.02L62.3402 65.03C69.8602 58.24 74.6102 48.45 74.6102 37.54C74.6102 17.09 57.9702 0.449951 37.5202 0.449951C17.0702 0.449951 0.430176 17.09 0.430176 37.54C0.430176 57.99 17.0702 74.63 37.5202 74.63C43.6302 74.63 49.3902 73.1199 54.4702 70.4899L78.8302 105.48C79.7602 106.82 81.2502 107.53 82.7602 107.53C83.7002 107.53 84.6602 107.25 85.4902 106.67C87.6602 105.16 88.2002 102.18 86.6802 100L86.7002 100.02ZM10.0102 37.55C10.0102 22.38 22.3502 10.04 37.5202 10.04C52.6902 10.04 65.0302 22.38 65.0302 37.55C65.0302 52.72 52.6902 65.06 37.5202 65.06C22.3502 65.06 10.0102 52.72 10.0102 37.55Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default SearchIcon;
